import { lazy } from "react";
import MapSlot from "../shared/MapSlot";
import type { PartnerMapSceneProps } from "./MapScene";

// MapLibre is big and browser-only, so it is its own chunk and never part of the page's first paint.
const MapScene = lazy(() => import("./MapScene"));

/** The partner map in its slot: see MapSlot for when it mounts. */
const LiveMap = (props: PartnerMapSceneProps) => (
	<MapSlot>
		<MapScene {...props} />
	</MapSlot>
);

export default LiveMap;
